import { yupResolver } from '@hookform/resolvers/yup'
import { useNavigation, useRoute } from '@react-navigation/native'
import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'
import * as yup from 'yup'

import { useAuthContext } from 'features/auth/context/AuthContext'
import { ProfileTypes } from 'features/identityCheck/pages/profile/enums'
import { statusActions, useStatus } from 'features/identityCheck/pages/profile/store/statusStore'
import { UseNavigationType, UseRouteType } from 'features/navigation/navigators/RootNavigator/types'
import { getSubscriptionHookConfig } from 'features/navigation/navigators/SubscriptionStackNavigator/getSubscriptionHookConfig'
import { useGetHeaderHeight } from 'shared/header/useGetHeaderHeight'
import { PageHeaderWithoutPlaceholder } from 'ui/components/headers/PageHeaderWithoutPlaceholder'

import { StatusFlatList, StatusForm } from './StatusFlatList'

const schema = yup.object().shape({
  selectedStatus: yup.string().required(),
})

export const SetStatus = () => {
  const { params } = useRoute<UseRouteType<'SetStatus'>>()
  const { navigate } = useNavigation<UseNavigationType>()
  const type = params?.type ?? ProfileTypes.IDENTITY_CHECK // Fallback to most common scenario
  const origin = params?.origin
  const freeOfferId = params?.freeOfferId

  const { user } = useAuthContext()
  const identityCheckAndRecapExistingDataConfig = 'Profil'
  const pageConfigByType = {
    [ProfileTypes.IDENTITY_CHECK]: identityCheckAndRecapExistingDataConfig,
    [ProfileTypes.BOOKING_FREE_OFFER_15_16]: 'Informations personnelles',
    [ProfileTypes.RECAP_EXISTING_DATA]: identityCheckAndRecapExistingDataConfig,
  }

  const storedStatus = useStatus()
  const { setStatus: setStoreStatus } = statusActions
  const defaultStatus = user?.activityId ?? storedStatus
  // isLoading from react-query is not support with mutateAsync
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const titleID = uuidv4()
  const {
    control,
    handleSubmit,
    watch,
    formState: { isValid: formIsValid },
  } = useForm<StatusForm>({
    defaultValues: { selectedStatus: defaultStatus ?? undefined },
    resolver: yupResolver(schema),
    mode: 'onChange',
  })

  const selectedStatus = watch('selectedStatus')

  useEffect(() => {
    if (selectedStatus) setStoreStatus(selectedStatus)
  }, [selectedStatus, setStoreStatus])

  const submitStatus = useCallback(
    async (formValues: StatusForm) => {
      if (!formValues.selectedStatus) return
      setIsLoading(true)
      setStoreStatus(formValues.selectedStatus)
      navigate(
        ...getSubscriptionHookConfig(
          'ActivationProfileRecap',
          (() => {
            if (origin) {
              return freeOfferId ? { type, origin, freeOfferId } : { type, origin }
            }
            return freeOfferId ? { type, freeOfferId } : { type }
          })()
        )
      )
      setIsLoading(false)
    },
    [freeOfferId, navigate, origin, setStoreStatus, type]
  )

  const headerHeight = useGetHeaderHeight()

  return (
    <React.Fragment>
      <PageHeaderWithoutPlaceholder title={pageConfigByType[type]} />
      <StatusFlatList
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        submitStatus={submitStatus}
        isChangeStatus={false}
        titleID={titleID}
        control={control}
        headerHeight={headerHeight}
        formIsValid={formIsValid}
      />
    </React.Fragment>
  )
}
